import React from 'react';

import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const Tag = ({
  children,
  icon,
  color = 'neutral',
  onRemove,
  close = false,
  size = 'small',
  variant = 'light',
  rightIcon
}) => {
  const heightClass = size === 'medium' ? 'h-6' : 'h-5';
  const paddingY = size === 'medium' ? 'px-2' : 'px-1.5';

  const colorClasses =
    variant === 'dark'
      ? `bg-${color}-300 border-${color}-400`
      : `bg-${color}-100 border-${color}-200`;

  return (
    <div
      className={cn(
        'flex w-fit items-center gap-0.5 rounded border border-solid',
        heightClass,
        paddingY,
        colorClasses
      )}>
      <div className="flex items-center gap-1">
        {icon && <Icon icon={icon} className="h-4 w-4" />}
        <Typography variant="label" size={size}>
          {children}
        </Typography>
        {rightIcon && <Icon icon={rightIcon} className="h-4 w-4" />}
      </div>
      {close && (
        <Icon
          icon="close-linear"
          className="h-4 w-4 cursor-pointer"
          onClick={() => onRemove(children)}
        />
      )}
    </div>
  );
};

export default Tag;
